import React, { useState, useEffect, useContext, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ApiService, { initialAuthState } from "../Services/ApiServices";
import { CartContext } from "../../contexts/CartContext";
import Navbar from "../New_Templates/Navbar";
import Footer from "../New_Templates/Footer";
import "./VerifyOtp.css";
import { BiSolidMapPin } from "react-icons/bi";
import { TfiTruck } from "react-icons/tfi";
import { BsFillFuelPumpFill } from "react-icons/bs";
import { MdLockOutline } from "react-icons/md";
import { useAuth } from "../../contexts/AuthContext";

function VerifyOtp() {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [timer, setTimer] = useState(60);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { refreshAuth } = useAuth();

  const location = useLocation();
  const phone = location.state?.phone;
  const navigate = useNavigate();

  const { addToCart, fetchCartItems } =
    useContext(CartContext);

  const inputRefs = useRef([]);

  useEffect(() => {
    if (!phone) {
      navigate("/login");
    }
  }, [phone]);

  /* ================= TIMER ================= */
  useEffect(() => {
    const interval = setInterval(() => {
      setTimer((t) => (t > 0 ? t - 1 : 0));
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (otp.every((d) => d !== "")) {
      handleVerify(); // auto verify
    }
  }, [otp]);

  useEffect(() => {
    if ("OTPCredential" in window) {
      const ac = new AbortController();

      if ("OTPCredential" in window && window.isSecureContext) {
        navigator.credentials
          .get({
            otp: { transport: ["sms"] },
            signal: ac.signal,
          })
          .then((otp) => {
            if (otp && otp.code) {
              fillOtp(otp.code);
            }
          })
          .catch(() => { });

      }

      return () => ac.abort();
    }
  }, []);

  useEffect(() => {
    inputRefs.current[0]?.focus();
  }, []);

  /* ================= INPUT HANDLING ================= */
  const handleChange = (index, value) => {
    if (!/^\d?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    setError("");

    if (value && index < 5) inputRefs.current[index + 1]?.focus();
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  // const handlePaste = (e) => {
  //   const paste = e.clipboardData.getData("text").trim();
  //   if (/^\d{6}$/.test(paste)) {
  //     setOtp(paste.split(""));
  //     inputRefs.current[5]?.focus();
  //   }
  // };

  const handlePaste = (e) => {
    const paste = e.clipboardData.getData("text");
    fillOtp(paste);
    e.preventDefault();
  };

  /* ================= MERGE CART ================= */
  const mergeGuestCart = async (clientId) => {
    const guestCart = JSON.parse(
      localStorage.getItem("guestCartItems") || "[]"
    );

    if (!guestCart.length) return;

    // await Promise.all(
    //   guestCart.map((item) => {
    //     const payload = { ...item, clientId };
    //     delete payload.id;
    //     return addToCart(payload);
    //   })
    // );

    await Promise.allSettled(
      guestCart.map((item) => {
        const payload = { ...item, clientId };
        delete payload.id;
        return addToCart(payload);
      })
    );

    localStorage.removeItem("guestCartItems");
  };

  /* ================= VERIFY ================= */
  const handleVerify = async () => {
    const fullOtp = otp.join("");

    if (fullOtp.length !== 6) {
      setError("Please enter complete OTP");
      return;
    }

    try {
      setLoading(true);

      const response = await ApiService.post("otp/verifyClientOtp", {
        companyCode: initialAuthState.companyCode,
        unitCode: initialAuthState.unitCode,
        phoneNumber: phone,
        otp: fullOtp,
      });

      if (!response.status) {
        setError("Invalid OTP. Try again.");
        setLoading(false);
        return;
      }

      const client = response?.data?.user;

      // const clientData = {
      //   client_id: client.clientId || "",
      //   client_db_id: client.id || "",
      //   client_name: client.name || "",
      //   client_phoneNumber: client.phoneNumber || "",
      // };

      // Object.entries(clientData).forEach(([k, v]) =>
      //   localStorage.setItem(k, v)
      // );

      await mergeGuestCart(client.id);
      await fetchCartItems();

      // 🔥 THIS IS THE KEY FIX

      await refreshAuth();
      window.location.href='/products'
      // navigate("/products");
    } catch (err) {
      console.error(err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  /* ================= RESEND ================= */
  const handleResendOtp = async () => {
    if (timer > 0) return;

    try {
      setLoading(true);

      const res = await ApiService.post("otp/reSendClientOtp", {
        companyCode: initialAuthState.companyCode,
        unitCode: initialAuthState.unitCode,
        phoneNumber: phone,
        isResend: true,
      });

      if (res.status) {
        setTimer(60);
        setOtp(["", "", "", "", "", ""]);
        inputRefs.current[0]?.focus();
      }
    } catch (err) {
      console.error(err);
      setError("Failed to resend OTP");
    } finally {
      setLoading(false);
    }
  };

  const fillOtp = (value) => {
    const clean = value.replace(/\D/g, "").slice(0, 6);

    if (clean.length === 6) {
      setOtp(clean.split(""));
      inputRefs.current[5]?.focus();
    }
  };

  /* ================= UI ================= */
  return (
    <>
      {/* <Navbar /> */}

      <div className="VerifyOtp-wrapper">
        <div className="VerifyOtp-bg-anim"></div>

        <div className="VerifyOtp-card">

          {/* LEFT */}
          <div className="VerifyOtp-left">
            <div className="VerifyOtp-left-content">
              <img
                src="/images/way4track-login-image.png"
                alt="OTP Verify"
                className="VerifyOtp-image"
              />

              <div className="VerifyOtp-overlay-text">
                <h2>Track Every Vehicle. Every Minute.</h2>
                <p>
                  Monitor your vehicles in real-time, reduce fuel misuse, and stay in control
                  of your operations from one dashboard.
                </p>

                <div className="VerifyOtp-features">
                  <span><BiSolidMapPin /> Live Tracking</span>
                  <span><TfiTruck /> Fleet Control</span>
                  <span><BsFillFuelPumpFill /> Fuel Insights</span>
                  <span><MdLockOutline /> Theft Alerts</span>
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT */}
          <div className="VerifyOtp-right">
            <div className="VerifyOtp-form">
              <div className="VerifyOtp-brand">
                <h2>Way4Track</h2>
                <p>Track Anything, Anytime, Anywhere</p>
              </div>

              <h3 className="VerifyOtp-title">Verify OTP</h3>
              <p>Code sent to +91 {phone}</p>

              <div className="VerifyOtp-otp" onPaste={handlePaste}>
                {otp.map((digit, i) => (
                  <input
                    key={i}
                    ref={(el) => (inputRefs.current[i] = el)}
                    type="text"
                    value={digit}
                    maxLength="1"
                    inputMode="numeric"
                    autoComplete={i === 0 ? "one-time-code" : "off"}
                    onChange={(e) => handleChange(i, e.target.value)}
                    onKeyDown={(e) => handleKeyDown(i, e)}
                  />
                ))}
              </div>

              {error && <div className="VerifyOtp-error">{error}</div>}

              <button
                className={`VerifyOtp-btn ${loading ? "loading" : ""}`}
                onClick={handleVerify}
                disabled={loading || otp.join("").length < 6}
              >
                {loading ? "Verifying..." : "Verify OTP"}
              </button>

              <div className="VerifyOtp-resend">
                {timer > 0 ? (
                  <span>Resend in 00:{timer.toString().padStart(2, "0")}</span>
                ) : (
                  <button onClick={handleResendOtp}>Resend OTP</button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <Footer /> */}
    </>
  );
}

export default VerifyOtp;

